import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ACCESS_LEVEL_OPTIONS, type AccessLevel } from "@/lib/enums";

/**
 * Like `EnumSelect`, but each option carries its one-line description so the
 * admin sees what a level means while choosing it. The trigger shows the
 * label alone.
 */
export function AccessLevelSelect({
  value,
  onValueChange,
  disabled,
}: {
  value: AccessLevel;
  onValueChange: (value: AccessLevel) => void;
  disabled?: boolean;
}) {
  const selected = ACCESS_LEVEL_OPTIONS.find((o) => o.value === value);
  return (
    <Select
      value={value}
      onValueChange={(next) => {
        const option = ACCESS_LEVEL_OPTIONS.find((o) => o.value === next);
        if (option) onValueChange(option.value);
      }}
      disabled={disabled}
    >
      <SelectTrigger className="w-full" aria-label="Access level">
        <SelectValue>{selected?.label}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {ACCESS_LEVEL_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value} className="py-2">
            <span className="flex flex-col items-start gap-0.5">
              <span className="font-medium">{option.label}</span>
              <span className="text-xs text-muted-foreground">{option.description}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
